document.addEventListener('DOMContentLoaded', () => {
  const playPauseBtn = document.getElementById('video-play-pause-btn');
  const videoDesktop = document.getElementById('video-desktop');
  const videoMobile = document.getElementById('video-mobile');
  const playIconContainer = document.getElementById('play-icon-container');
  const pauseIconContainer = document.getElementById('pause-icon-container');

  if (!playPauseBtn) return;

  function getActiveVideo() {
    if (window.innerWidth >= 1024) {
      return videoDesktop;
    }
    return videoMobile;
  }

  function updateButtonUI(isPlaying) {
    playPauseBtn.setAttribute('data-state', isPlaying ? 'playing' : 'paused');

    if (isPlaying) {
      playIconContainer.classList.add('hidden');
      pauseIconContainer.classList.remove('hidden');
    } else {
      playIconContainer.classList.remove('hidden');
      pauseIconContainer.classList.add('hidden');
    }
  }

  function togglePlayPause() {
    const video = getActiveVideo();
    if (!video) return;

    if (video.paused) {
      video.play();
      updateButtonUI(true);
    } else {
      video.pause();
      updateButtonUI(false);
    }
  }

  playPauseBtn.addEventListener('click', togglePlayPause);

  if (videoDesktop) {
    videoDesktop.addEventListener('click', togglePlayPause);
  }
  if (videoMobile) {
    videoMobile.addEventListener('click', togglePlayPause);
  }

  const handleVideoPlay = () => updateButtonUI(true);
  const handleVideoPause = () => updateButtonUI(false);

  if (videoDesktop) {
    videoDesktop.addEventListener('play', handleVideoPlay);
    videoDesktop.addEventListener('pause', handleVideoPause);
  }

  if (videoMobile) {
    videoMobile.addEventListener('play', handleVideoPlay);
    videoMobile.addEventListener('pause', handleVideoPause);
  }

  window.addEventListener('resize', () => {
    const video = getActiveVideo();
    if (video) {
      updateButtonUI(!video.paused);
    }
  });
});
